import { BookOpen } from "lucide-react";
import { Link } from "react-router-dom";
import type { Job } from "../../lib/api";
import { assetPath } from "./exports";

/** A link to the register entry for a tag, from any screen that knows the package and tag. */
export function AssetLink({ pkg, tag }: { pkg: string; tag: string }) {
  return (
    <Link to={assetPath(pkg, tag)} className="row" style={{ gap: 4, fontSize: 13 }} title={`Register entry for ${tag}`}>
      <BookOpen size={14} aria-hidden="true" /> Register entry
    </Link>
  );
}

/** The package and tag a vendor check came from, or null for a part entered by hand. */
export function sourceAsset(
  job: { source_job_id: string | null }, uc1Jobs: Pick<Job, "id" | "package" | "tag">[],
): { package: string; tag: string } | null {
  const source = job.source_job_id ? uc1Jobs.find((j) => j.id === job.source_job_id) : undefined;
  return source ? { package: source.package, tag: source.tag } : null;
}
